let counter;
let inactivityCallback;

/**
 * This function sets up a callback which is called after a specified duration
 * of inactivity.
 *
 * This function has side effects!  It hijacks a number of high level window events.
 *
 * For example, this could be used to refresh the page after 10 minutes of inactivity.
 * @param callback a function to run after timeoutSec of inactivity on the page
 * @param timeoutSec the period in seconds to wait before running the callback
 * @returns A function that will cancel the detector when invoked.  It will not
 *          clean up the modified window event handlers though.
 */
export default function inactivityDetector (callback, timeoutSec) {
  inactivityCallback = callback

  function resetTimer () {
    counter = 0
  }

  window.onload = resetTimer
  window.onmousemove = resetTimer
  window.onmousedown = resetTimer // catches touchscreen presses as well
  window.ontouchstart = resetTimer // catches touchscreen swipes as well
  window.onclick = resetTimer // catches touchpad clicks as well
  window.onkeydown = resetTimer
  window.addEventListener('scroll', resetTimer, true) // improved; see comments

  return setInterval(() => {
    counter += 1
    if (counter >= timeoutSec) {
      inactivityCallback()
    }
  }, 1000) // Once every second
}
